import React, { useState, useEffect, useRef } from 'react';
import APIs from '../../APIs';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { setUserData } from "../../redux/authSlice";

import { motion } from "framer-motion"; // for text animation
import { toast } from "react-toastify";
import { clearPickupDropoff } from "../../redux/addressSlice";
import { clearShipment } from "../../redux/shipmentSlice";
const Home = () => {
 const [categories, setCategories] = useState([]);
    const [services, setServices] = useState([]);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [toastData, setToastData] = useState(null); 
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleCategoryClick = (categoryId) => {
    // Clear Redux state
    dispatch(clearPickupDropoff());
    dispatch(clearShipment());

    // Clear or set sessionStorage
    sessionStorage.removeItem("shipment_id");
    sessionStorage.removeItem("existingQuoteId");
    sessionStorage.removeItem("currentQuoteId");
    sessionStorage.removeItem("categoryName");
    sessionStorage.removeItem("categoryDescription");     
     // Set categoryId
    sessionStorage.setItem("categoryId", categoryId);

    // Navigate to Step1
    navigate(`/Step1/${categoryId}`);
  };
const testimonials = [
  {
    name: "Hazel Jenkins",
    role: "Ceo & Founder",
    rating: 5,
    feedback:
      "I would recommend practitioners at this center to everyone! They are great to work with and are excellent",
  },
  {
    name: "Dylan Wang",
    role: "Manager",
    rating: 4,
    feedback:
      "I would recommend practitioners at this center to everyone! They are great to work with and are excellent",
  },
  {
    name: "Naomi Violet",
    role: "Manager",
    rating: 5,
    feedback:
      "I would recommend practitioners at this center to everyone! They are great to work with and are excellent",
  },
  {
    name: "Parsons William",
    role: "Co Founder",
    rating: 5,
    feedback:
      "I would recommend practitioners at this center to everyone! They are great to work with and are excellent",
  },
  {
    name: "Ariana Green",
    role: "Satisfied Client",
    rating: 5,
    feedback:
      "I would recommend practitioners at this center to everyone! They are great to work with and are excellent",
  },
  {
    name: "Justin Aria",
    role: "Customer",
    rating: 5,
    feedback:
      "I would recommend practitioners at this center to everyone! They are great to work with and are excellent",
  },
];
    useEffect(() => {
        getCategories();
        getAllServices();
    }, []);

    const getCategories = async () => {
        try {
            const response = await APIs.get('category/getAllCategory', {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (response.data.status === "success") {
                setCategories(response.data.data); // Adjust if your API returns a different structure
            }
        } catch (error) {
            // Optionally handle error
            setCategories([]);
        }
    };

    const getAllServices = async () => {

        try {
            const response = await APIs.get('service/getAllService', {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            console.log('Get Service Response -', response.data);

            if (response.data.status === "success") {
                setServices(response.data.data);
            }

        } catch (error) {
            if (error.response) {
                const { statusCode, message } = error.response.data;

                if (statusCode === 401) {
                    setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
                } else if (statusCode === 422) {
                    setToastData({ title: 'Service', message: message, type: 'info', id: Date.now() });
                } else if (statusCode === 409) {
                    setToastData({ title: 'Service', message: message, type: 'warning', id: Date.now() });
                } else if (statusCode === 400 || statusCode === 404) {
                    setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
                } else if (statusCode === 500) {
                    setToastData({ title: 'Service', message: message, type: 'danger', id: Date.now() });
                }
            } else {
                setToastData({ title: 'Service', message: error.message, type: 'danger', id: Date.now() });
            }
        }
    }
    const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    mobile_number: "",
    subject: "",
    message: "",
  });

  const [statusMessage, setStatusMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.full_name.trim()) newErrors.full_name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    if (!formData.mobile_number.trim()) newErrors.mobile_number = "Phone number is required.";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
    if (!formData.message.trim()) newErrors.message = "Message is required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    setLoading(true);

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      const response = await APIs.post("user/addFeedback", formData);
      const data = response.data;

      toast.success(data.message || "Feedback submitted successfully!", {position: "top-right"});
      setFormData({ full_name: "", email: "", mobile_number: "", subject: "", message: "" });
      setErrors({});
    } catch (error) {
      toast.error(
        error.response?.data?.message
          ? error.response.data.message
          : "Error submitting feedback: " + error.message
      );
    } finally {
      setLoading(false);
    }
  };
    return (
        <>
          <div className="page-wrapper">
          
            { /* About-us start */}
            <section className="about-section-two section-md">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 eagle-left-col">
                            <div className="about-image">
                                <div className="about-contant">
                                    <div className="pbminfotech-ele-fid-style-2">
                                        <div className="eagle-fld-contents">
                                            <div className="eagle-fld-wrap">
                                                <h4 className="eagle-fid-inner">
                                                    <span className="eagle-fid-before"><sup>*</sup></span>
                                                    <span className="eagle-number-rotate" data-appear-animation="animateDigits" data-from="0" data-to="235" data-interval="5" data-before="" data-before-style="" data-after="" data-after-style="">235</span>
                                                    <span className="eagle-fid"><sup>+</sup></span>
                                                </h4>
                                            </div>
                                            <div className="eagle-fid-icon-title">
                                                <span className="eagle-fid-title">Happy Customers</span>
                                            </div>
                                        </div>
                                        <div className="eagle-sticky-corner eagle-bottom-left-corner">
                                            <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M30 30V0C30 16 16 30 0 30H30Z"></path>
                                            </svg>
                                        </div>
                                        <div className="eagle-sticky-corner eagle-top-right-corner">
                                            <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M30 30V0C30 16 16 30 0 30H30Z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 eagle-right-col">
                            <div className="about-wrap">
                                <div className="eagle-heading-subheading animation-style2">
                                    <h4 className="eagle-subtitle">
                                        <span></span>
                                        About Eagle OBC
                                    </h4>
                                    <h2 className="eagle-title">Innovating Logistics, Ensuring Excellence</h2>
                                    <div className="eagle-heading-desc">The efficiency and reliability of transport systems play a crucial role in connecting communities.
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="ihbox-bg">
                                            <div className="eagle-ihbox-style-1">
                                                <div className="eagle-ihbox-headingicon">
                                                    <div className="eagle-ihbox-icon">
                                                        <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-icon">
                                                            <div className="eagle-icon-wrapper eagle-icon-type-icon">
                                                                <i className="flaticon-planet-earth"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="eagle-ihbox-contents">
                                                        <h2 className="eagle-element-title">Worldwide Services</h2>
                                                        <div className="eagle-heading-desc">We’re always provide people a complete solution focused of any business.</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="ihbox-inner">
                                            <div className="eagle-ihbox-style-1">
                                                <div className="eagle-ihbox-headingicon">
                                                    <div className="eagle-ihbox-icon">
                                                        <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-icon">
                                                            <div className="eagle-icon-wrapper eagle-icon-type-icon">
                                                                <i className="flaticon-truck"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="eagle-ihbox-contents">
                                                        <h2 className="eagle-element-title">Local Service</h2>
                                                        <div className="eagle-heading-desc">We’re always provide people a complete solution focused of any business.</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="about-button">
                                    
                                    
                                        <Link to="/about-us" className="eagle-btn eagle-btn-blackish">
                                        <span className="eagle-button-text">Know More</span>
                                        <span className="eagle-button-icon-wrapper">
                                            <span className="eagle-button-icon">
                                                <i className="eagle-base-icon-black-arrow-1"></i>
                                            </span>
                                        </span>
                                        </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            { /* About-us End */}
            { /* Ihbox Start */}
            <section className="ihbox-section-two section-lgb">
              <div className="container">
                <div className="ihbox-contant">
                  <div className="eagle-ele-header-align-center">
                    <div className="eagle-heading-subheading  text-center animation-style2">
                      <h4 className="eagle-subtitle">
                        <span></span>
                        WE’RE EXPERTIES
                      </h4>
                      <h2 className="eagle-title">Explore Our Specialized Category</h2>
                    </div>
                  </div>

                  <div className="row">
                    {categories && categories.length > 0 ? (
                      categories.map((cat, idx) => (
                        <div className="col-md-4 mb-3" key={cat._id || cat.category_id || idx}>
                          <div  onClick={() => handleCategoryClick(cat._id || cat.category_id)} style={{ cursor: "pointer" }}>
                            <div className="eagle-ihbox-style-3">
                              <div className="eagle-ihbox-box">
                                <div className="eagle-ihbox-icon">
                                  <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-image">
                                    <img
                                      src={
                                        cat.category_image ||
                                        "images/homepage-2/ihbox/icon-img-01.png"
                                      }
                                      alt={cat.category_name}
                                    />
                                  </div>
                                </div>
                                <div className="eagle-ihbox-contents">
                                  <h2 className="eagle-element-title">
                                    {cat.title || cat.category_name}
                                  </h2>
                                  <div className="eagle-heading-desc">
                                    {cat.desc || cat.category_description}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center">No categories found.</div>
                    )}
                  </div>
                </div>
              </div>
            </section>

            { /* Ihbox End */}

              {/* Service Start */}
            <section className="service-section-one section-md eagle-bg-color-global eagle-extend-animation" width="100%">
              <div className="service-wrap">
                <div className="container eagle-col-stretched-yes eagle-col-right">
                  {/* Heading */}
                  <div className="position-relative text-center mb-10">
                    <div className="eagle-heading-subheading animation-style2">
                      <h4 className="eagle-subtitle">SERVICES</h4>
                      <h2 className="eagle-title">What We Do</h2>
                    </div>
                  </div>

                  {/* Swiper Slider */}
                  <div className="eagle-col-stretched-right">
                    <Swiper
                      modules={[Navigation, Pagination, Autoplay, EffectFade]}
                      autoplay={{ delay: 3000 }}
                      loop={true}
                      pagination={{ clickable: true }}
                      navigation={false}
                      slidesPerView={3.6}
                      spaceBetween={30}
                      className="swiper-slider"
                      
                    >
                      {services.map((service, index) => (
                        <SwiperSlide key={index}>
                          <article className="eagle-service-style-2">
                            <div className="pbminfotech-post-item">
                              <div className="pbminfotech-box-content">
                                {/* Service Image */}
                                <div className="eagle-service-image-wrapper">
                                  <div className="eagle-featured-img-wrapper">
                                    <div className="eagle-featured-wrapper">
                                      <img src={service.service_image} alt={service.service_name} />
                                    </div>
                                  </div>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="119.09"
                                    height="112.42"
                                    viewBox="0 0 119.09 112.42"
                                  >
                                    <path d="M.05,110.13a85.42,85.42,0,0,0,20.78-2c12.23-2.83,20.86-9.88,25.28-21.69,2.55-6.82,4.71-13.79,7.13-20.66C57,55,64.39,48,75.55,45.07c5-1.31,9.92-2.7,14.82-4.26,17.66-5.65,25.37-15.63,26.55-34.2.14-2.16.09-4.32.13-6.48,2.5-.63,2,1.17,2,2.5q0,17.75,0,35.5v74q-57.75,0-115.5-.07C2.34,112.05-.42,113.66.05,110.13Z"></path>
                                  </svg>
                                </div>

                                {/* Service Icon */}
                                <div className="eagle-service-icon">
                                  <i className={`eagle-evgrid-icon ${service.icon}`}></i>
                                </div>

                                {/* Content Box */}
                                <div className="eagle-content-box">
                                  <h3 className="eagle-service-title">
                                    <Link
                                    to="/"
                                    title={service.service_name}
                                    >{service.service_name}</Link>
                                  </h3>
                                  <div className="eagle-service-description">
                                    <p>{service.service_description}</p>
                                  </div>
                                </div>
                              </div>

                            
                                <Link
                                    className="eagle-service-btn"
                                    to="/"
                                    title={service.service_name}
                                    >
                                  
                                <span className="eagle-button-icon-wrapper">
                                  <span className="eagle-button-icon">
                                    <i className="eagle-base-icon-black-arrow-1"></i>
                                  </span>
                                </span>
                                </Link>
                            </div>
                            <Link
                                    className="eagle-link"
                                    to="/"
                                    title={service.service_name}
                                    ></Link>
                          </article>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            </section>

            {/* Service End */}
          
            {/* Marquee Start */}
            <section className="marquee-section-two">
              <div className="container-fluid p-0">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={50}
                  slidesPerView={"auto"}
                  loop={true}
                  freeMode={true}            // allows smooth continuous scrolling
                  speed={3000}               // adjust speed for slow scroll
                  autoplay={{
                    delay: 0,                // no delay between slides
                    disableOnInteraction: false,
                  }}
                  className="marquee"
                >
                  {["Air Freight", "Logistics", "Delivery Service", "Tracking"].map(
                    (text, index) => (
                      <SwiperSlide
                        key={index}
                        className="eagle-marquee-effect-style-1"
                        style={{ width: "auto" }} // important for continuous scroll
                      >
                        <div className="eagle-tag-wrapper">
                          <h2 className="eagle-element-title" data-text={text}>
                            {text}
                          </h2>
                        </div>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </div>
            </section>
            {/* Marquee End */}

              { /* Sidebar Start */ }
            <section className="sidebar-section-one">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 sidebar-left-col eagle-sticky-column">
                            <div className="theiaStickySidebar">
                                <div className="sidebar-image">
                                    <img src="images/homepage-1/bg/about-img-01.jpg" className="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 sidebar-right-col">
                            <div className="sidebar-wrap">
                                <div className="eagle-heading-subheading animation-style2">
                                    <h4 className="eagle-subtitle">
                                        <span></span>
                                      How It Works
                                    </h4>
                                    <h2 className="eagle-title">How Eagle OBC Works</h2>
                                </div>
                                <div className="row">
                                    <article className="eagle-miconheading-style-10 col-md-12">
                                        <div className="eagle-ihbox eagle-ihbox-style-10">
                                            <div className="eagle-ihbox-box">
                                                <div className="eagle-ihbox-icon">
                                                    <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-text">01</div>
                                                </div>  
                                                <div className="eagle-ihbox-contents">
                                                    <h2 className="eagle-element-title">Submit Your Request</h2>
                                                    <div className="eagle-heading-desc">Use our website to get an instant quote and book your courier.</div>            
                                                </div>
                                            </div>                      
                                        </div>
                                    </article>
                                    <article className="eagle-miconheading-style-10 col-md-12">
                                        <div className="eagle-ihbox eagle-ihbox-style-10">
                                            <div className="eagle-ihbox-box">
                                                <div className="eagle-ihbox-icon">
                                                    <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-text">02</div>
                                                </div>  
                                                <div className="eagle-ihbox-contents">
                                                    <h2 className="eagle-element-title">We Assign a Courier</h2>
                                                    <div className="eagle-heading-desc">Based on availability, location, and urgency, we assign a vetted on-board courier.</div>            
                                                </div>
                                            </div>                      
                                        </div>
                                    </article>
                                    <article className="eagle-miconheading-style-10 col-md-12">
                                        <div className="eagle-ihbox eagle-ihbox-style-10">
                                            <div className="eagle-ihbox-box">
                                                <div className="eagle-ihbox-icon">
                                                    <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-text">03</div>
                                                </div>  
                                                <div className="eagle-ihbox-contents">
                                                    <h2 className="eagle-element-title">Pickup & Flight</h2>
                                                    <div className="eagle-heading-desc">Your item is picked up and boarded on the next commercial flight.</div>            
                                                </div>
                                            </div>                      
                                        </div>
                                    </article>
                                    <article className="eagle-miconheading-style-10 col-md-12">
                                        <div className="eagle-ihbox eagle-ihbox-style-10">
                                            <div className="eagle-ihbox-box">
                                                <div className="eagle-ihbox-icon">
                                                    <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-text">04</div>
                                                </div>  
                                                <div className="eagle-ihbox-contents">
                                                    <h2 className="eagle-element-title">Doorstep Delivery</h2>
                                                    <div className="eagle-heading-desc">Our courier hand-delivers the item at the destination address.</div>            
                                                </div>
                                            </div>                      
                                        </div>
                                    </article>
                                    <article className="eagle-miconheading-style-10 col-md-12">
                                        <div className="eagle-ihbox eagle-ihbox-style-10">
                                            <div className="eagle-ihbox-box">
                                                <div className="eagle-ihbox-icon">
                                                    <div className="eagle-ihbox-icon-wrapper eagle-ihbox-icon-type-text">05</div>
                                                </div>  
                                                <div className="eagle-ihbox-contents">
                                                    <h2 className="eagle-element-title">Track & Notify</h2>
                                                    <div className="eagle-heading-desc">You receive real-time updates every step of the way.</div>            
                                                </div>
                                            </div>                      
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </section>
            { /* Sidebar End */}

            { /* Testimonial Start */}
            <section className="testimonial-section-two section-md d-none">
              <div className="testimonial-contant">
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-md-12">
                      <div className="eagle-header-area">
                        <div className="eagle-heading-subheading animation-style2">
                          <h4 className="eagle-subtitle">
                            <span></span> Feedback
                          </h4>
                          <h2 className="eagle-title">Hear From Our Clients.</h2>
                        </div>
                        <div className="testimonial-wrapper">
                          <div className="testimonial-swiper-arrow d-inline-flex flex-row-reverse"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Swiper Section */}
                <div className="container-fluid">
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    autoplay={{ delay: 3000 }}
                    loop={true}
                    navigation={{
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    }}
                    slidesPerView={3.6}
                    spaceBetween={30}
                    className="swiper-slider"
                  >
                    {testimonials.map((item, index) => (
                      <SwiperSlide key={index}>
                        <article className="eagle-testimonial-style-1">
                          <div className="pbminfotech-post-item">
                            <div className="pbminfotech-post-inner d-flex align-items-center">
                              {/* Author Info */}
                              <div className="pbminfotech-box-author">
                                <h3 className="pbminfotech-box-title">{item.name}</h3>
                                <div className="pbminfotech-testimonial-detail">
                                  {item.role}
                                </div>
                              </div>

                              {/* Feedback Content */}
                              <div className="eagle-box-content-wrap">
                                <div className="pbminfotech-box-star-ratings">
                                  {Array.from({ length: 5 }).map((_, starIndex) => (
                                    <i
                                      key={starIndex}
                                      className={`eagle-base-icon-star-1 ${
                                        starIndex < item.rating ? "eagle-active" : ""
                                      }`}
                                    ></i>
                                  ))}
                                </div>
                                <div className="pbminfotech-box-desc">
                                  <blockquote className="pbminfotech-testimonial-text">
                                    <p>“{item.feedback}”</p>
                                  </blockquote>
                                </div>
                              </div>
                            </div>

                            {/* Decorative SVG */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="111.45"
                              height="105.95"
                              viewBox="0 0 111.45 105.95"
                            >
                              <path d="M8.7,1.1c10.9,1,16,2.2,22.4,5.5,9.4,4.7,13.8,11.1,19.4,27.9,8,23.8,11.4,27.3,33,33.6,25.3,7.3,32,14.5,34.5,37.4.4,3.9.8-17.9.9-49.3L119,0,59.3.1C20.2.2,2.7.6,8.7,1.1Z"></path>
                            </svg>
                          </div>
                        </article>
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  {/* Custom Nav Buttons */}
                  <div className="swiper-button-prev">‹</div>
                  <div className="swiper-button-next">›</div>
                </div>
              </div>
            </section>
          
            { /* Testimonial End */}

            { /* Contact-us Start */}
            <section className="contact-us-section-two section-md">
      <div className="container">
        <div className="row">
          <div className="col-md-6 contact-left-col">
            <div className="contact-us-two"></div>
          </div>
          <div className="col-md-6 contact-right-col">
            <div className="contact-wrap eagle-bg-color-blackish">
              <div className="eagle-heading-subheading animation-style2">
                <h4 className="eagle-subtitle">
                  <span></span>
                  Connect With Us!
                </h4>
                <h2 className="eagle-title">Do you need help? Contact with us!</h2>
              </div>

              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-sm-12 col-md-6 mb-3">
                    <input
                      type="text"
                      className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                      placeholder="Your Name *"
                      name="full_name"
                      value={formData.full_name}
                      onChange={handleChange}
                    />
                    {errors.full_name && <small className="text-danger">{errors.full_name}</small>}
                  </div>

                  <div className="col-sm-12 col-md-6 mb-3">
                    <input
                      type="email"
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      placeholder="Your Email *"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && <small className="text-danger">{errors.email}</small>}
                  </div>

                  <div className="col-sm-12 col-md-6 mb-3">
                    <input
                      type="tel"
                      className={`form-control ${errors.mobile_number ? "is-invalid" : ""}`}
                      placeholder="Your Phone *"
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={handleChange}
                    />
                    {errors.mobile_number && <small className="text-danger">{errors.mobile_number}</small>}
                  </div>

                  <div className="col-sm-12 col-md-6 mb-3">
                    <input
                      type="text"
                      className={`form-control ${errors.subject ? "is-invalid" : ""}`}
                      placeholder="Subject *"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                    {errors.subject && <small className="text-danger">{errors.subject}</small>}
                  </div>

                  <div className="col-md-12 mb-3">
                    <textarea
                      name="message"
                      cols="40"
                      rows="5"
                      className={`form-control ${errors.message ? "is-invalid" : ""}`}
                      placeholder="Message *"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                    {errors.message && <small className="text-danger">{errors.message}</small>}
                  </div>

                  <div className="col-md-12 text-center mb-3">
                    <button type="submit" className="eagle-btn" disabled={loading}>
                      <span className="eagle-button-text">{loading ? "Submitting..." : "Submit Now"}</span>
                      <span className="eagle-button-icon-wrapper">
                        <span className="eagle-button-icon">
                          <i className="eagle-base-icon-black-arrow-1"></i>
                        </span>
                      </span>
                    </button>
                  </div>

                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </section>
            { /* Contact-us End */}

                
          </div>
          
        </>
    )
}

export default Home;